module.exports = __webpack_public_path__ + "img/blown.3f918fd5.png";